import get from 'lodash/get';
$ const {
  title,
  inputField
} = input;
$ const callToAction = get(input, 'callToAction', {});
$ const cancel = get(callToAction, 'cancel', {
  label: ''
});
$ const confirm = get(callToAction, 'confirm', {
  label: ''
});
$ const textCounterEnabled = get(inputField, 'textCounterEnabled', false);
$ const inputLabel = get(inputField, 'label', false);
$ const inputPlaceholder = get(inputField, 'placeholder', false);
$ const maxLength = get(inputField, 'maxLength', false);
$ const isInvalid = state.errorMessage.length > 0;
<div class="prompt-dialog">
  <ebay-confirm-dialog open=state.open on-open('emit', 'open') on-close('emit', 'close') on-reject('handleCancel') on-confirm('handleConfirm')>
    <@header>
      <div class="prompt-dialog__header">
        ${title}
        <ebay-icon-button on-click('emit', "close")>
          <ebay-close-16-icon/>
        </ebay-icon-button>
      </div>
    </@header>
    <div class="prompt-dialog__input-field">
      <ebay-textbox value=state.inputValue floatingLabel=inputLabel placeholder=inputPlaceholder class="prompt-dialog__input" on-input-change("handleInputChange") invalid=isInvalid/>
      <div class="prompt-dialog__input-tips">
        <div>
          <if(state.errorMessage.length > 0)>
            <p class="prompt-dialog__input-error">
              <ebay-attention-filled-16-icon/>
              <span>
                ${state.errorMessage}
              </span>
            </p>
          </if>
        </div>
        <div class="prompt-dialog__text-counter">
          <if(textCounterEnabled)>
            ${state.inputValue.length}/${maxLength}
          </if>
        </div>
      </div>
    </div>
    <@reject>
      ${cancel.label}
    </@reject>
    <@confirm>
      ${confirm.label}
    </@confirm>
  </ebay-confirm-dialog>
</div>